import { MoovyPalette, MoovyStyle } from '../styles/theme'

import { createTheme } from '@mui/material'

const smBreakpoint = 600

export default createTheme({
  palette: {
    primary: {
      main: MoovyPalette.primaryMain,
    },
    secondary: {
      main: MoovyPalette.secondaryMain,
    },
    error: {
      main: MoovyPalette.errorMain,
    },
    warning: {
      main: MoovyPalette.warningMain,
    },
    info: {
      main: MoovyPalette.infoMain,
    },
    success: {
      main: MoovyPalette.successMain,
    },
    text: {
      primary: MoovyPalette.commonBlack,
    },
    common: {
      black: MoovyPalette.commonBlack,
      white: MoovyPalette.commonWhite,
    },
  },
  shape: {
    borderRadius: 10,
  },
  typography: {
    fontFamily: MoovyStyle.fontFamily,
    htmlFontSize: MoovyStyle.htmlFontSize,
    fontSize: MoovyStyle.fontSizeMobile,
    body1: {
      fontSize: MoovyStyle.fontSizeMobile,
      [`@media (min-width:${smBreakpoint}px)`]: {
        fontSize: MoovyStyle.fontSizeDesktop,
      },
    },
    body2: {
      fontSize: MoovyStyle.fontSizeMobile * 0.8,
      [`@media (min-width:${smBreakpoint}px)`]: {
        fontSize: MoovyStyle.fontSizeDesktop * 0.8,
      },
    },
    h1: {
      fontSize: MoovyStyle.fontSizeMobile * 2.5,
      [`@media (min-width:${smBreakpoint}px)`]: {
        fontSize: MoovyStyle.fontSizeDesktop * 2.5,
      },
      fontWeight: 'bold',
    },
    h2: {
      fontSize: MoovyStyle.fontSizeMobile * 2,
      [`@media (min-width:${smBreakpoint}px)`]: {
        fontSize: MoovyStyle.fontSizeDesktop * 2,
      },
      fontWeight: 'bold',
    },
    h3: {
      fontSize: MoovyStyle.fontSizeMobile * 1.75,
      [`@media (min-width:${smBreakpoint}px)`]: {
        fontSize: MoovyStyle.fontSizeDesktop * 1.75,
      },
      fontWeight: 'bold',
    },
    h4: {
      fontSize: MoovyStyle.fontSizeMobile * 1.5,
      [`@media (min-width:${smBreakpoint}px)`]: {
        fontSize: MoovyStyle.fontSizeDesktop * 1.5,
      },
      fontWeight: 'bold',
    },
    h5: {
      fontSize: MoovyStyle.fontSizeMobile * 1.25,
      [`@media (min-width:${smBreakpoint}px)`]: {
        fontSize: MoovyStyle.fontSizeDesktop * 1.25,
      },
      fontWeight: 'bold',
    },
    h6: {
      fontSize: MoovyStyle.fontSizeMobile * 1.1,
      [`@media (min-width:${smBreakpoint}px)`]: {
        fontSize: MoovyStyle.fontSizeDesktop * 1.1,
      },
      fontWeight: 'bold',
    },
    subtitle1: {
      fontSize: MoovyStyle.fontSizeMobile * 1.1,
      [`@media (min-width:${smBreakpoint}px)`]: {
        fontSize: MoovyStyle.fontSizeDesktop * 1.1,
      },
    },
    subtitle2: {
      fontSize: MoovyStyle.fontSizeMobile * 0.9,
      [`@media (min-width:${smBreakpoint}px)`]: {
        fontSize: MoovyStyle.fontSizeDesktop * 0.9,
      },
    },
    button: {
      fontSize: MoovyStyle.fontSizeMobile,
      [`@media (min-width:${smBreakpoint}px)`]: {
        fontSize: MoovyStyle.fontSizeDesktop,
      },
      textTransform: 'none',
    },
    caption: {
      fontSize: MoovyStyle.fontSizeMobile * 0.75,
      [`@media (min-width:${smBreakpoint}px)`]: {
        fontSize: MoovyStyle.fontSizeDesktop * 0.75,
      },
    },
    overline: {
      fontSize: MoovyStyle.fontSizeMobile * 0.75,
      [`@media (min-width:${smBreakpoint}px)`]: {
        fontSize: MoovyStyle.fontSizeDesktop * 0.75,
      },
      textTransform: 'uppercase',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        a: {
          color: MoovyPalette.commonBlue,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: MoovyStyle.buttonFontWeight,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: MoovyPalette.colorTableHeader,
          '& .MuiTableCell-root': {
            fontWeight: MoovyStyle.tableHeadFontWeight,
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& input:-webkit-autofill': {
            '-webkit-text-fill-color': MoovyPalette.commonBlack,
          },
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          cursor: 'pointer',
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          display: 'flex',
          alignItems: 'center',
          paddingBottom: '0',
          paddingTop: '2px',
          paddingLeft: '2px',
          paddingRight: '0',
          margin: '0',
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          paddingLeft: '10px',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        standardInfo: {
          backgroundColor: MoovyPalette.colorMainBackground,
          color: MoovyPalette.secondaryMain,
          '& .MuiAlert-icon': {
            color: MoovyPalette.secondaryMain,
          },
        },
      },
    },
  },
})
